const gridContainerStyles = {
    grid: {
        marginRight: '-15px',
        marginLeft: '-15px',
        width: 'auto'
    }
};

export default gridContainerStyles;
